<!-- <span *ngIf="menuItem.group">
  <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon>
  {{ menuItem.title }}
</span> -->
<a *ngIf="(!menuItem.type || menuItem.type == 'button' ) && !menuItem.children && !menuItem.group"
  (click)="goToPage(menuItem.isHeaderItem, menuItem.link)" [queryParams]="menuItem.queryParams"
  [fragment]="menuItem.fragment" [queryParamsHandling]="menuItem.queryParamsHandling"
  [preserveFragment]="menuItem.preserveFragment" [skipLocationChange]="menuItem.skipLocationChange"
  [attr.target]="menuItem.target" [attr.title]="menuItem.title" [class.active]="menuItem.selected"
  routerLinkActive="active">
  <div class="menu-icon-wrapper">
    <i class="menu-icon isax" [class]="menuItem.icon" *ngIf="menuItem.icon"></i>
    <!-- <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon> -->
  </div>
  <span class="menu-title" *ngIf="menuItem.title">{{ menuItem.title }}</span>
  <ng-container *ngIf="badge" [ngTemplateOutlet]="badgeTemplate"></ng-container>
</a>
<div *ngIf="menuItem.type == 'hr'" class="hr"></div>
<div *ngIf="menuItem.type == 'label'" class="label">
  <i class="menu-icon isax" [class]="menuItem.icon" *ngIf="menuItem.icon"></i>
  <!-- <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon> -->
  <span class="menu-title menu-header" *ngIf="menuItem.title">{{ menuItem.title }}</span>
</div>
<!-- <a *ngIf="menuItem.link && !menuItem.url && !menuItem.children && !menuItem.group"
   [routerLink]="menuItem.link"
   [queryParams]="menuItem.queryParams"
   [fragment]="menuItem.fragment"
   [queryParamsHandling]="menuItem.queryParamsHandling"
   [preserveFragment]="menuItem.preserveFragment"
   [skipLocationChange]="menuItem.skipLocationChange"
   [attr.target]="menuItem.target"
   [attr.title]="menuItem.title"
   [class.active]="menuItem.selected"
   (mouseenter)="onHoverItem(menuItem)"
   (click)="onItemClick(menuItem);">
  <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon>
  <span class="menu-title">{{ menuItem.title }}</span>
  <ng-container *ngIf="badge" [ngTemplateOutlet]="badgeTemplate"></ng-container>
</a> -->
<!-- <a *ngIf="menuItem.url && !menuItem.children && !menuItem.link && !menuItem.group"
   [attr.href]="menuItem.url"
   [attr.target]="menuItem.target"
   [attr.title]="menuItem.title"
   [class.active]="menuItem.selected"
   (mouseenter)="onHoverItem(menuItem)"
   (click)="onSelectItem(menuItem)">
  <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon>
  <span class="menu-title">{{ menuItem.title }}</span>
  <ng-container *ngIf="badge" [ngTemplateOutlet]="badgeTemplate"></ng-container>
</a>
<a *ngIf="!menuItem.children && !menuItem.link && !menuItem.url && !menuItem.group" class="unlinked-tab">
  <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon>
  <span class="menu-title">{{ menuItem.title }}</span>
  <ng-container *ngIf="badge" [ngTemplateOutlet]="badgeTemplate"></ng-container>
</a>
<a *ngIf="menuItem.children"
   (click)="$event.preventDefault(); onToggleSubMenu(menuItem);"
   [attr.target]="menuItem.target"
   [attr.title]="menuItem.title"
   [class.active]="menuItem.selected"
   (mouseenter)="onHoverItem(menuItem)"
   href="#">
  <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon>
  <span class="menu-title">{{ menuItem.title }}</span>
  <ng-container *ngIf="badge" [ngTemplateOutlet]="badgeTemplate"></ng-container>
  <nb-icon class="expand-state" [icon]="getExpandStateIcon()" pack="nebular-essentials"></nb-icon>
</a>
<ul *ngIf="menuItem.children"
    [class.collapsed]="!(menuItem.children && menuItem.expanded)"
    [class.expanded]="menuItem.expanded"
    [@toggle]="toggleState"
    class="menu-items">
  <ng-container *ngFor="let item of menuItem.children">
    <li nbMenuItem *ngIf="!item.hidden"
        [menuItem]="item"
        [badge]="item.badge"
        [class.menu-group]="item.group"
        (hoverItem)="onHoverItem($event)"
        (toggleSubMenu)="onToggleSubMenu($event)"
        (selectItem)="onSelectItem($event)"
        (itemClick)="onItemClick($event)"
        class="menu-item">
    </li>
  </ng-container>
</ul> -->
<!-- <a href="javascript:void" *ngIf="menuItem.children" class="active">
  <nb-accordion class="active">
    <nb-accordion-item>
      <nb-accordion-item-header>
        <div class="menu-icon-wrapper">
          <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon>
        </div>
        <div>{{menuItem.title}}</div>
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <a [routerLink]="child.link" [queryParams]="child.queryParams" [fragment]="child.fragment"
          [queryParamsHandling]="child.queryParamsHandling" [preserveFragment]="child.preserveFragment"
          [skipLocationChange]="child.skipLocationChange" [attr.target]="child.target" [attr.title]="child.title"
          [class.active]="child.selected" routerLinkActive="active" *ngFor="let child of menuItem.children">
          <div class="menu-icon-wrapper">
            <nb-icon class="menu-icon fal" pack="fontawesome" [class]="child.icon" *ngIf="child.icon"></nb-icon>
          </div>
          <span class="menu-title" *ngIf="child.title">{{ child.title }}</span>
          <ng-container *ngIf="badge" [ngTemplateOutlet]="badgeTemplate"></ng-container>
        </a>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>
</a> -->
<a *ngIf="menuItem.children" [attr.target]="menuItem.target" [attr.title]="menuItem.title"
  [class.active-menu]="menuItem.selected" (mouseenter)="onHoverItem(menuItem)" href="#"
  (click)="$event.preventDefault(); onToggleSubMenu(menuItem);" routerLinkActive="active">
  <div class="menu-icon-wrapper">
    <i class="menu-icon" [class]="menuItem.icon" *ngIf="menuItem.icon"></i>
    <!-- <nb-icon class="menu-icon fal" pack="fontawesome" [class]="menuItem.icon" *ngIf="menuItem.icon"></nb-icon> -->
  </div>
  <span class="menu-title" *ngIf="menuItem.title">{{ menuItem.title }}</span>
  <ng-container *ngIf="badge" [ngTemplateOutlet]="badgeTemplate"></ng-container>
  <nb-icon class="expand-state" [icon]="getExpandStateIcon()" pack="nebular-essentials"></nb-icon>
</a>
<ul *ngIf="menuItem.children && menuItem.expanded" class="menu-items dg-submenu" [@dropDownMenu]>
  <ng-container *ngFor="let item of menuItem.children">
    <li nbMenuItem [menuItem]="item" *ngIf="!item.hidden" (hoverItem)="onHoverItem($event)"
      (toggleSubMenu)="onToggleSubMenu($event)" (selectItem)="onSelectItem($event)" (itemClick)="onItemClick($event)"
      class="menu-item">
      <a (click)="goToPage(menuItem.isHeaderItem, item.link)" [queryParams]="item.queryParams"
        [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling"
        [preserveFragment]="item.preserveFragment" [skipLocationChange]="item.skipLocationChange"
        [attr.target]="item.target" [attr.title]="item.title" [class.active-submenu]="item.selected"
        routerLinkActive="active-submenu active">
        <div class="menu-icon-wrapper">
          <i class="menu-icon" [class]="item.icon" *ngIf="item.icon"></i>
          <!-- <nb-icon class="menu-icon fal" pack="fontawesome" [class]="item.icon" *ngIf="item.icon"></nb-icon> -->
        </div>
        <span class="menu-title" *ngIf="item.title">{{ item.title }}</span>
        <ng-container *ngIf="badge" [ngTemplateOutlet]="badgeTemplate"></ng-container>
      </a>
    </li>
  </ng-container>
</ul>

<ng-template #badgeTemplate>
  <nb-badge [text]="badge.text" [dotMode]="badge.dotMode" [status]="badge.status">
  </nb-badge>
</ng-template>